/** English (default) — nested keys for i18next (`t('header.title')`). */
export const en = {
  header: {
    brandAlt: 'Avatar',
    /** `{{name}}` from GET /v1/config.name (falls back to brandAlt). */
    title: 'Chat with {{name}}',
    subtitle: 'Ask, discover, or get help instantly',
    reset: 'Reset conversation',
  },
  chat: {
    typing: 'Avatar is typing…',
    errorFallback:
      "Sorry about this. I'm unable to assist with your request right now due to a temporary issue on our side. Please try again shortly.",
    networkError: 'Network error. Please check your connection and try again.',
    widgetDisabled:
      'This chat is no longer available. New messages cannot be sent right now.',
    originNotAllowlisted:
      "This site is not allowlisted for this avatar. Ask your admin to add '{{origin}}'.",
    identifyDisabled: 'Identity verification is disabled for this avatar.',
    retry: 'Try again',
    streamingPlaceholder: '…',
    newConversationStarted: 'New conversation started',
    yesterday: 'Yesterday',
  },
  input: {
    placeholder: 'Ask anything...',
    ariaLabel: 'Message Avatar',
    send: 'Send message',
    poweredBy: 'Powered by Avatar.inc',
  },
  popular: {
    ariaLabel: 'Suggested questions',
  },
  doc: {
    title: 'Avatar Widget',
  },
} as const;

/** Same tree as `en`, but values are plain strings (other locales). */
export type EnTranslation = {
  [K in keyof typeof en]: {
    [P in keyof (typeof en)[K]]: string;
  };
};
